import { useTranslation } from 'react-i18next';
import { isTraditionalChinese } from '../i18n/content';

export function LanguageToggle() {
  const { i18n, t } = useTranslation();
  const isZhTW = isTraditionalChinese(i18n.resolvedLanguage ?? i18n.language);

  const toggle = () => i18n.changeLanguage(isZhTW ? 'en' : 'zh-TW');

  return (
    <button
      onClick={toggle}
      className="ctrl-btn"
      aria-label={t(isZhTW ? 'common.switchLanguage' : 'common.switchToChinese')}
    >
      {isZhTW ? 'EN' : '中文'}
    </button>
  );
}
